/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { ClosedEnum } from "../../types/enums.js";

export const LinkCardWaitFor = {
  PaymentMethod: "payment-method",
} as const;
export type LinkCardWaitFor = ClosedEnum<typeof LinkCardWaitFor>;

/** @internal */
export const LinkCardWaitFor$inboundSchema: z.ZodNativeEnum<
  typeof LinkCardWaitFor
> = z.nativeEnum(LinkCardWaitFor);
/** @internal */
export const LinkCardWaitFor$outboundSchema: z.ZodNativeEnum<
  typeof LinkCardWaitFor
> = LinkCardWaitFor$inboundSchema;
